import request from '@/utils/request'
import axios from 'axios'

const pythonApi = axios.create({
  baseURL: '/python-api/',
  timeout: 10000
})

pythonApi.interceptors.response.use(
  (response) => {
    const data = response.data
    if (data.code === 200) {
      return {
        msg: data.msg || '获取成功',
        data: data.data
      }
    }
    return Promise.reject(new Error(data.msg || '请求失败'))
  },
  (error) => {
    console.error('Python API 请求失败:', error)
    return Promise.reject(error)
  }
)

export function getDoc() {
  return request({
    url: '/markdown',
    method: 'get',
    params: null
  })
}
// 添加 qry 函数用于查询文章列表，支持分页和条件过滤
export function qry(pageNum = 1, pageSize = 10, post = {}) {
  return request({
    url: '/web/client/post/qry',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      ...post
    }
  })
}

// 获取 CSDN RSS 订阅数据
export function getCsdnRss() {
  return pythonApi.get('/api/csdn/rss')
}

export function getGiteeRepos(params = {}) {
  return pythonApi.get('/api/gitee/repos', { params })
}
